export const youRamObserver = () => {

    // const loadMoreButton = document.querySelector('.yl-load-more-button');
    const loadMoreButton = document.querySelector('.plethoraplugins-tabs--content');
    
    const loadMoreButtonElemList = document.querySelectorAll('.yl-load-more-button');
    for(var i=0; i < loadMoreButtonElemList.length; i++) {
        var loadMoreButtonElem = loadMoreButtonElemList[i];
        console.log('loadMoreButtonElem', loadMoreButtonElem);
        if ( loadMoreButtonElem.textContent.indexOf('(0)') !== -1 ){
            console.log("Mutated as Load More is not required");
            loadMoreButtonElem.style.display = "none";
        }
        else {
            loadMoreButtonElem.style.display = "block";
        }
    }    

    // Options for the observer (which mutations to observe)
    const classMutationConfig = { characterData: false, attributes: false, childList: true, subtree: true };

    const classMutationCallback = (mutationsList, observer) => {
        
        for(const mutation of mutationsList) {
            console.log('mutation', mutation);
            if ( mutation.type === 'childList' ) {
                const loadMoreButtonElem = document.querySelector('.plethoraplugins-tabs--content > .active .yl-load-more-button');
                console.log('loadMoreButtonElem', loadMoreButtonElem);
				if ( loadMoreButtonElem.textContent.indexOf('(0)') !== -1 ){
					console.log("Mutated as Load More is not required");
					loadMoreButtonElem.style.display = "none";
				}
                else {
					loadMoreButtonElem.style.display = "block";
                }
            }
        }
    }

    /**
     * Class mutation observer
     * @type {MutationObserver}
     */
    const observer = new MutationObserver(classMutationCallback);

    if(loadMoreButton){
        //Observe for class mutations
        observer.observe(loadMoreButton, classMutationConfig);
    }
}